import { graphql } from "./generated/gql";

export const TemplatePresetsQuery = graphql(`
  query TemplatePresets {
    templatePresets {
      nodes {
        templatePresetId
        name
        description
        itemCount
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const TemplatePresetItemsQuery = graphql(`
  query TemplatePresetItems($templatePresetId: ID!) {
    templatePresetItems(templatePresetId: $templatePresetId) {
      nodes {
        templatePresetItemId
        templatePresetId
        category
        timeEstimate
        itemName
        question
        note
        isRequired
        order
      }
      totalCount
    }
  }
`);

export const CreateTemplatePresetMutation = graphql(`
  mutation CreateTemplatePreset($input: CreateTemplatePresetInput!) {
    createTemplatePreset(input: $input) {
      templatePresetId
      name
      description
      itemCount
    }
  }
`);

export const UpdateTemplatePresetMutation = graphql(`
  mutation UpdateTemplatePreset($input: UpdateTemplatePresetInput!) {
    updateTemplatePreset(input: $input) {
      templatePresetId
      name
      description
      itemCount
    }
  }
`);

export const DeleteTemplatePresetMutation = graphql(`
  mutation DeleteTemplatePreset($templatePresetId: ID!) {
    deleteTemplatePreset(templatePresetId: $templatePresetId)
  }
`);

export const BulkCreateTemplatePresetItemsMutation = graphql(`
  mutation BulkCreateTemplatePresetItems(
    $input: BulkCreateTemplatePresetItemsInput!
  ) {
    bulkCreateTemplatePresetItems(input: $input) {
      totalCount
    }
  }
`);

export const ApplyTemplatePresetToTermMutation = graphql(`
  mutation ApplyTemplatePresetToTerm($input: ApplyTemplatePresetToTermInput!) {
    applyTemplatePresetToTerm(input: $input) {
      totalCount
    }
  }
`);
